import $ from 'jquery'

export function ratingHistogram() {
  const $histogram = $('.review_rating');

  if ( SOPHIA.isIos() ) {
    $histogram.on('click', function(e) {
      e.preventDefault();

      if ($('.joyride-list').is(':hidden')) {
        $('.joyride-list').fadeIn();
      } else {
        $('.joyride-list').fadeOut();
      }

      $(document).on('touchstart', function(e) {
        e.preventDefault();
        $('.joyride-list').fadeOut();
        $(document).off('touchstart');
      });
    });
    $(window).on('resize', function() {
      $('.joyride-list').fadeOut();
    });
  } else {
    // Rating histogram
    $histogram.on('mouseenter', function() {
      $('.joyride-list').fadeIn();
    }).on('mouseleave', function() {
      $('.joyride-list').fadeOut();
    });

    if ($histogram) {
      $histogram.on('focusin', function() {
        $('.joyride-list').fadeIn();

        $histogram.on('focusout', function(){
          $('.joyride-list').fadeOut();
        });
      });
    }
  }
}
